var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1766 4470 c-111 -18 -211 -50 -321 -105 -296 -147 -500 -413 -571 -741 -20 -95 -23 -301 -5 -394 55 -294 223 -547 468 -707 106 -69 190 -107 311 -141 88 -24 113 -27 272 -27 151 0 186 3 260 23 309 84 558 286 694 565 204 415 122 903 -206 1228 -134 133 -302 228 -486 275 -109 28 -313 40 -416 24z m304 -436 c175 -41 340 -172 419 -334 69 -141 86 -268 55 -418 -47 -233 -230 -425 -465 -488 -83 -22 -234 -23 -316 -1 -331 87 -538 419 -468 752 48 231 244 434 470 489 80 19 224 19 305 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4400 3184 c-22 -9 -174 -154 -402 -382 l-368 -367 -153 152 c-91 91 -167 158 -190 168 -135 56 -285 -32 -295 -174 -8 -105 -2 -113 257 -374 245 -247 296 -287 369 -287 95 0 88 -6 575 479 301 301 464 470 477 497 83 170 -97 362 -270 288z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640 2115 c-676 -93 -1179 -503 -1207 -986 -4 -63 -2 -108 7 -132 52 -159 271 -192 370 -56 16 23 32 55 34 73 3 17 9 62 15 101 40 269 360 498 801 572 127 21 393 21 520 0 277 -47 508 -153 655 -302 88 -89 133 -173 146 -276 15 -107 26 -144 56 -179 89 -106 256 -97 338 18 29 43 30 47 30 155 0 89 -5 128 -24 187 -133 428 -591 746 -1189 825 -137 18 -419 18 -552 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.234c72dc7f259639dc93d07255ba39fa.svg";
export { ForwardRef as ReactComponent };